import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4" data-id="element-48">
      {items.map((item, index) => <div key={index} className="glass rounded-2xl overflow-hidden" data-id="element-49">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-50">
            <span className="font-serif text-xl text-white" data-id="element-51">
              {item.question}
            </span>
            <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-52" />
          </button>
          <AnimatePresence data-id="element-53">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-54">
                <div className="px-6 pb-6 text-beige-muted border-t border-white/5 pt-4" data-id="element-55">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}